module.exports = __webpack_public_path__ + "static/media/categories-logo-adobe.e994f659.svg";